import React from 'react';

export default function SmsRetention() {
    return <div>SmsRetention</div>;
}
